import { render, staticRenderFns } from "./Renderer.vue?vue&type=template&id=0633ba5a&"
import script from "./Renderer.vue?vue&type=script&lang=js&"
export * from "./Renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports